var View = require('views/base/view');
var CourseMapView = require('./course-map-view');
var GuidesOverlayView = require('./guides-overlay-view');

var ToolBarView = View.extend({
  autoRender: true,
  autoAttach: true,
  className: 'col-md-12',
  template: require('./templates/toolbar'),
  regions: {
    achecker: 'achecker-report',
    course_map: '#course_map_pane'
  },
  initialize: function() {
    this.on('addedToDOM', function() {
      this.delegate('click', '#refresh_achecker', this.submitAChecker);
      this.delegate('click', '#guides-overlay-button', this.openGuidesOverlay);
      this.$('#accessibility').on('shown.bs.tab', () => this.submitAChecker());
      this.delegate('click', '.page-skipping-container .btn', this.setPageSkipping);
      var courseMap = new CourseMapView({
        collection: EF.modules,
        region: 'course_map'
      });
      this.subview('course_map', courseMap);
    });
    View.prototype.initialize.apply(this, arguments);
  },
  submitAChecker: function() {
    var html = '<!DOCTYPE>' + document.documentElement.outerHTML;
    $('#achecker_html').val(html);
    $('#achecker_form').submit();
  },
  openGuidesOverlay: function() {
    let guidesOverlayView = new GuidesOverlayView();
    guidesOverlayView.render();
  },
  setPageSkipping(e) {
    EF.options.pageSkipping = e.currentTarget.querySelector('input').value === 'true';
    localStorage.setItem('pageSkipping', EF.options.pageSkipping);
  },
  getTemplateData() {
    return {
      pageSkipping: EF.options.pageSkipping
    };
  }
});

module.exports = ToolBarView;
